export class SectionTitleButton {
  label: string;
  title: string;
  icon: string;
  onclick: any;
  class: string;
}
